import React, { useState } from 'react';
import moment from 'moment';
import OutsideClickHandler from 'react-outside-click-handler';

import { getUrlDataAdminUrl } from '../../helpers/url_data_agent_live_matches_helpers';
import { useWindowKeydown } from '../../hooks/useWindowKeydown';
import { useLinksToCheckContext } from './LinksToCheckContext';

import './TodayPopover.scss';

const TODAY_LIMIT = 8;

/** How many links you did today, and the latest ones with a way to change each in URL Data. */
const TodayPopover = () => {
  const { today } = useLinksToCheckContext();
  const [isOpen, setIsOpen] = useState(false);
  const entries = today.entries.slice(0, TODAY_LIMIT);

  useWindowKeydown(e => {
    if (e.key === 'Escape' && isOpen) setIsOpen(false);
  });

  return (
    <OutsideClickHandler onOutsideClick={() => setIsOpen(false)} disabled={!isOpen}>
      <div className='links-to-check-today'>
        <button type='button' className='today-button' aria-expanded={isOpen} onClick={() => setIsOpen(!isOpen)}>
          <b>{today.count}</b> done today
        </button>
        {isOpen && (
          <div className='today-popover'>
            {entries.length ? (
              entries.map(entry => (
                <div key={entry.key} className='today-row'>
                  <span className='today-label'>{entry.label}</span>
                  <span className='today-time'>{moment.utc(entry.at).local().format('h:mm a')}</span>
                  <a href={getUrlDataAdminUrl(entry)} target='_blank' rel='noopener noreferrer'>
                    Change
                  </a>
                </div>
              ))
            ) : (
              <div className='today-empty'>Nothing yet today.</div>
            )}
          </div>
        )}
      </div>
    </OutsideClickHandler>
  );
};

export default TodayPopover;
